import(/* webpackMode: "eager", webpackExports: ["LeaderboardAd","BillboardAd","InterstitialAd","BottomAnchorAd"] */ "/app/apps/web/components/ads/ad-types.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ComingSoon"] */ "/app/apps/web/components/placeholder/coming-soon.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PrintTitle"] */ "/app/apps/web/components/print/print-title.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/packages/core/src/cache/client-cache-provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/core/src/config/client-config-provider.tsx");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/assets/scoreboard_logo_alt_centered_white.png");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/assets/scoreboard_logo_alt_centered.png");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/assets/scoreboard_logo_white.png");
;
import(/* webpackMode: "eager" */ "/app/packages/ui/assets/scoreboard_logo.png");
;
import(/* webpackMode: "eager", webpackExports: ["TimezoneProvider"] */ "/app/packages/ui/components/client-time.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Mascot"] */ "/app/packages/ui/components/mascot.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LiveBadgeBase"] */ "/app/packages/ui/shell/badges/live-badges.tsx");
